export default __webpack_public_path__ + "static/media/Berat.9293b44b.png";